import { render, staticRenderFns } from "./Container.vue?vue&type=template&id=647c2eb4&"
import script from "./Container.vue?vue&type=script&lang=js&"
export * from "./Container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('647c2eb4')) {
      api.createRecord('647c2eb4', component.options)
    } else {
      api.reload('647c2eb4', component.options)
    }
    module.hot.accept("./Container.vue?vue&type=template&id=647c2eb4&", function () {
      api.rerender('647c2eb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/v3/components/SnackBar/Container.vue"
export default component.exports